import React from "react";
import { Star } from "lucide-react";

export default function StarRating({ value, onChange, size = 18 }) {
  return (
    <div className="inline-flex gap-0.5" role="radiogroup" aria-label="Rating">
      {[1, 2, 3, 4, 5].map((n) => (
        <button type="button" key={n} onClick={() => onChange?.(n)} role="radio" aria-checked={value === n} aria-label={`${n} star${n > 1 ? "s" : ""}`}
          className="p-0.5 transition-transform hover:scale-110" disabled={!onChange}>
          <Star size={size} className={n <= value ? "text-orange-500" : "text-slate-300"} fill={n <= value ? "currentColor" : "none"} />
        </button>
      ))}
    </div>
  );
}
